export const accountSelector = (state) => state.stripeReducer.account;
